export default __webpack_public_path__ + "535d60e23c3579c330309f1d4690a4d5.png";